"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBOUNCE_FORM_OFFSET = exports.DEBOUNCE_TIME = exports.FORM_ERRORS_HEADER = exports.FIELD_TYPE_NAMES = void 0;
exports.FIELD_TYPE_NAMES = {
    NAME: 'name',
    STRING: 'string',
    SELECT: 'select',
    SIMPLE_SELECT: 'simpleSelect',
    ADDRESS: 'address',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    MULTI_SELECT: 'multiSelect',
    TYPEAHEAD: 'typeahead',
    PHONE: 'phone',
    EMAIL: 'email',
    ARRAY: 'array',
    INLINE: 'inline',
    DOB: 'dob',
    TEXTAREA: 'textarea',
    SSN: 'ssn',
    PARTIAL_SSN: 'partialSsn',
    DATE: 'date',
    TIME: 'time',
    NPI: 'npi',
    HIDDEN: 'hidden',
    AGE_GROUPS_SEEN: 'ageGroupsSeen',
    FILE: 'file'
};
exports.FORM_ERRORS_HEADER = 'Please fix the following errors:';
exports.DEBOUNCE_TIME = 250;
exports.DEBOUNCE_FORM_OFFSET = 100;
//# sourceMappingURL=index.js.map